import type { MeasurementAccessType } from "@msuite/utils/types";
import { createContext, useContext } from "react";

interface IMeasurementContext {
	type: MeasurementAccessType;
}

/** Context */
export const MeasurementContext = createContext<IMeasurementContext>({} as IMeasurementContext);

/** Hooks */
export function useMeasurementContext() {
	return useContext(MeasurementContext);
}
